import React, { useState } from 'react';
import Lottie from 'lottie-react';
import islamicLoaderAnimation from '../assets/animations/islamic-loader.json';

const GlobalLoader: React.FC = () => {
  const [lottieError, setLottieError] = useState(false);

  if (lottieError) {
    return (
      <div className="global-loader" role="status" aria-label="Loading">
        <div className="spinner-border text-primary" style={{ width: '3rem', height: '3rem' }}>
          <span className="visually-hidden">Loading...</span>
        </div>
        <p className="global-loader__text">Loading BMCS...</p>
      </div>
    );
  }

  return (
    <div className="global-loader" role="status" aria-label="Loading">
      <div className="global-loader__lottie">
        <Lottie
          animationData={islamicLoaderAnimation}
          loop
          style={{ width: 160, height: 160 }}
          onDataFailed={() => setLottieError(true)}
        />
      </div>
      <p className="global-loader__text">Loading BMCS...</p>
    </div>
  );
};

export default GlobalLoader;
